import React from 'react';
import { searchNormaliz, productNameNormaliz } from '../utils/stringUtil';

type HighlightedSearchTextProps = {
    searchWord: string; // 検索文字列
    showName: string; // 検索結果の表示用文字列
    showNameSearch: string; // 検索結果の文字列
};

// 機種名の検索ワードに当てはまる箇所を強調する
export const HighlightedSearchText: React.FC<HighlightedSearchTextProps> = ({
    searchWord,
    showName,
    showNameSearch,
}) => {
    const normalizedSearchWord: string = searchNormaliz(searchWord);
    const normalizedProductName: string = productNameNormaliz(showName);

    let front: string;
    let highlight: string;
    let rear: string;

    if (normalizedSearchWord.length === 0) {
        front = showName;
        highlight = '';
        rear = '';
    } else {
        const fromIdx = showNameSearch.indexOf(normalizedSearchWord);
        if (fromIdx === -1) {
            front = showName;
            highlight = '';
            rear = '';
        } else {
            const startPosition: number = normalizedProductName.indexOf(normalizedSearchWord.charAt(0), fromIdx);

            let i = 0;
            let endPosition: number = startPosition;
            while (endPosition < normalizedProductName.length) {
                const curEndName = normalizedProductName.charAt(endPosition);
                const curInputChar = normalizedSearchWord.charAt(i);
                if (curEndName === curInputChar) {
                    i++;
                    if (i >= normalizedSearchWord.length) {
                        break;
                    }
                }
                endPosition++;
            }

            front = startPosition > 0 ? showName.substring(0, startPosition) : '';
            highlight = showName.substring(startPosition, endPosition + 1);
            rear = endPosition < showName.length ? showName.substring(endPosition + 1) : '';
        }
    }

    return (
        <>
            {front}
            <strong>{highlight}</strong>
            {rear}
        </>
    );
};
